import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@nrwl/environment';
import { HttpClient } from '@angular/common/http';
import { PneAppointment } from '@nrwl/rx-models';

@Injectable({
  providedIn: 'root',
})
export class PneEmrService {
  constructor(private readonly _http: HttpClient) {}

  public getInsurancePlans(): Observable<any> {
    return this._http.get(environment.baseAPIUrlMicro + 'egress-proxy/pne/insurancepayers');
  }

  public getCustomerInsurances(customerId: string | number): Observable<any> {
    return this._http.get(
      environment.baseAPIUrlMicro + 'egress-proxy/pne/customerinsurance/' + customerId,
    );
  }

  public getAppointments(companyId: number | string): Observable<PneAppointment[]> {
    return this._http.get<PneAppointment[]>(
      environment.baseAPIUrlMicro + 'egress-proxy/pne/appointments',
      {
        params: { CompanyId: companyId },
      },
    );
  }

  public getAppointmentsFiltered(customerId: number | string): Observable<PneAppointment[]> {
    const today = new Date().toISOString().split('T')[0];

    const url =
      environment.baseAPIUrlMicro + `egress-proxy/pne/customers/${customerId}/Appointments`;
    const params = { StartDate: today };

    return this._http.post<PneAppointment[]>(url, {}, { params });
  }

  public getTreatmentByAppointment(
    appointmentId: number | string,
    legacyIds = true,
  ): Observable<string | number | null> {
    const url = `${environment.baseAPIUrlMicro}egress-proxy/pne/appointments/${appointmentId}/treatment/`;
    const params = { legacyids: legacyIds.toString() };

    return this._http.get<{ treatmentId?: string | number }>(url, { params }).pipe(
      map((res) => (res && res.treatmentId ? res.treatmentId : null)),
    );
  }
}
